


































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import Quill from 'quill'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

@Component({
  components: {
    PicModal
  }
})
export default class EditorCustomize extends Vue {
  /**
   * quill-editor 编辑器内容在其他页面展示时 需要用以下样式包裹
   * <div class="ql-container ql-snow">
   *  <div class="ql-editor" v-html="content"></div>
   * </div>
   */
  // 编辑器内容
  @Prop({ type: String, default: null })
  content!: string

  editorOption = {
    modules: {
      // imageDrop: true,
      // imageResize: {
      //   displaySize: true,
      //   modules: ['Resize', 'DisplaySize', 'Toolbar'],
      //   handleStyles: {
      //     backgroundColor: 'black',
      //     border: 'none',
      //     color: 'white'
      //     // other camelCase styles for size display
      //   }
      // },
      toolbar: '#toolbar'
    }
  }

  showPicModal = false

  myContent = null

  @Watch('content')
  showChange(content) {
    this.myContent = content
  }

  mounted() {}

  /**
   * 选择图片
   */
  picChange(event) {
    const quill = (this.$refs.myQuillEditor as any).quill
    let cursor = quill.selection.savedRange.index // 获取光标位置
    event.forEach(item => {
      quill.insertEmbed(cursor, 'image', item.url) // 把图片插到光标的地方
      quill.setSelection(cursor + 1) // 把光标移到图片的后面
      cursor ++
    })
  }

  // 富文本编辑器 失去焦点事件
  onEditorBlur(editor) {}
  // 富文本编辑器 获得焦点事件
  onEditorFocus(editor) {}
  // 富文本编辑器 内容改变事件
  onEditorChange(editor) {
    this.$emit('on-change', editor.html)
  }
  resetContent() {
    (this.$refs.myQuillEditor as any).quill.setContents([]);
  }
}
